module.exports = __webpack_public_path__ + "static/media/filter.c29a9db3.svg";